export default function (ConfigProvider, LoopBackResourceProvider) {
  'ngInject';

  const config = ConfigProvider.$get();
  LoopBackResourceProvider.setUrlBase(config.get('restApiUrl'));
}
